import { Weaver } from 'html-text-weaver';

const weaver = new Weaver();

const encode = (html) => {
  if (html === undefined) { return { text: '', meta: [] }; }
  return weaver.encode(html);
};

const decode = ({ text, meta }) => {
  if (text === undefined) return '';
  return weaver.decode({ text, meta: meta || [] });
};

export default {
  decode,
  encode
};



// WEBPACK FOOTER //
// ./starling/src/lib/rich-text.js